module.exports = __webpack_public_path__ + "static/media/under_construction.7d9bb9cd.png";